module.exports = __webpack_public_path__ + "static/03-895cd2d2aaf201ce8e46af893492860f.jpg";